import { Component, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { SharedService } from "@/app/shared/services/shared.service";
import { PermissionAction } from "../../interfaces/role.interface";
import { environment } from '@/environments/environment';
import { isDevMode } from '@angular/core';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {

  // @Select(AccountState.user) user$: Observable<AccountUser>;
  // @Select(SettingState.setting) setting$: Observable<Values>;
  // @Select(NotificationState.notification) notification$: Observable<Notification[]>;
  public PermissionAction = PermissionAction;
  public unreadNotificationCount: number | undefined;

  public active: boolean = false;
  public profileOpen: boolean = false;
  public open: boolean = false;

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      icon: 'us'
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'fr'
    },
  ];

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    icon: 'us'
  }

  public setting: any;

  constructor(@Inject(DOCUMENT) private document: Document,
    public sharedServices: SharedService) {
    // this.notification$.subscribe((notification) => {
    //   this.unreadNotificationCount = notification?.filter(item => !item.read_at)?.length;
    // });
    // this.setting$.subscribe(setting => {
    //   document.body.classList.add(setting?.general?.mode!);
    // })
  }

  sidebarToggle() {
    this.sharedServices.collapseSidebar = !this.sharedServices.collapseSidebar;
  }

  clickHeaderOnMobile() {
    this.sharedServices.search = true;
  }
  
  isDevelopmentMode(): boolean {
    return !environment.production && isDevMode();
  }
}
